import { Injectable } from '@angular/core';
import { Form, ReadonlyState } from '../models/form.model';
import { RendererFormsRepository } from '../repositories/renderer-forms.repository';
import { RendererSectionsCommand } from './renderer-sections.command';

@Injectable({ providedIn: 'root' })
export class RendererFormCommand {
  constructor(
    protected rendererFormsRepository: RendererFormsRepository,
    protected rendererSectionsCommand: RendererSectionsCommand,
  ) {}

  public setForm(form: Form) {
    this.rendererSectionsCommand.reset();
    this.rendererSectionsCommand.setSections(form.sections);

    this.rendererFormsRepository.upsert(form);
  }

  public setReadOnly(readOnly: ReadonlyState) {
    this.rendererFormsRepository.setReadonly(readOnly);
  }

  public setIsLoading(isLoading: boolean) {
    this.rendererFormsRepository.setLoading(isLoading);
  }

  public setActive(formId: string) {
    this.rendererFormsRepository.setActive(formId);
  }

  public unsetActive() {
    // eslint-disable-next-line unicorn/no-null
    this.rendererFormsRepository.setActive(null);
  }

  public setHideSections(hideSections: string[]) {
    this.rendererFormsRepository.setHideSections(hideSections);
  }
}
